import { render } from "./Underground.vue?vue&type=template&id=4e316be6&scoped=true"
import script from "./Underground.vue?vue&type=script&lang=js"
export * from "./Underground.vue?vue&type=script&lang=js"

import "./Underground.vue?vue&type=style&index=0&id=4e316be6&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e316be6"]])

export default __exports__